import { createRoot } from 'react-dom/client'

import './styles/tokens.css'
import './styles/global.css'
import './styles/components.css'
import './styles/elevation.css'
import './styles/pages.css'

import { initTheme } from './lib/theme'
import { startConfiguredApplication } from './lib/frontendStartup.mjs'
import './styles/startup.css'

// R7 · U540 — the appearance preference is applied ONCE, for every surface.
// It used to be applied only where the shell's theme toggle happened to mount,
// so the landing and auth pages silently ignored a member's stored choice.
initTheme()

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element #root not found')

const root = createRoot(rootEl)
const startupText = {
  en: {
    title: 'Takeed Community',
    configuration: 'This service is not configured for this environment. Please contact your platform administrator.',
    loading: 'The service could not start. Please reload the page to try again.',
    reload: 'Reload',
  },
  ar: {
    title: 'مجتمع تأكيد',
    configuration: 'الخدمة غير مهيأة في هذه البيئة. يرجى التواصل مع مسؤول المنصة.',
    loading: 'تعذّر بدء الخدمة. يرجى إعادة تحميل الصفحة للمحاولة مجددًا.',
    reload: 'إعادة التحميل',
  },
}

function showUnavailable(kind: 'configuration' | 'loading') {
  // Do not import the application or its Supabase client to render this state.
  // No endpoint, key, account detail or raw exception belongs in this notice.
  root.render(
    <main className="tk-startup-notice" aria-labelledby="startup-title">
      <h1 id="startup-title">{startupText.en.title}</h1>
      <div role="alert">
        <p lang="en" dir="ltr">{startupText.en[kind]}</p>
        <p lang="ar" dir="rtl">{startupText.ar[kind]}</p>
      </div>
      <button type="button" onClick={() => window.location.reload()}>
        <span lang="en">{startupText.en.reload}</span>{' / '}<span lang="ar" dir="rtl">{startupText.ar.reload}</span>
      </button>
    </main>,
  )
}

void startConfiguredApplication({
  url: import.meta.env.VITE_SUPABASE_URL,
  key: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  load: async () => {
    const { mountCommunity } = await import('./mountCommunity')
    mountCommunity(root)
  },
  unavailable: showUnavailable,
})
